"use client";

import { useEffect } from "react";

import { captureAnalyticsException } from "@/shared/analytics";

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    captureAnalyticsException(error, {
      digest: error.digest ?? null,
      source: "global_error_boundary",
    });
  }, [error]);

  return (
    <html lang="uz">
      <body>
        <main style={{ display: "grid", minHeight: "100vh", placeItems: "center", padding: 24 }}>
          <div style={{ maxWidth: 420, textAlign: "center" }}>
            <h1>Something went wrong</h1>
            <p>Unexpected application error.</p>
            <button type="button" onClick={reset}>
              Try again
            </button>
          </div>
        </main>
      </body>
    </html>
  );
}
